import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import { useTranslation } from "react-i18next";
import "./ConfirmationModal.css";

const ConfirmationModal = ({ open, onClose, onConfirm, title, message }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle className='modal-confirm-title'>{title}</DialogTitle>
      <DialogContent>
        <p>{message}</p>
      </DialogContent>
      <DialogActions className='modal-confirm-btns'>
        <Button onClick={onConfirm} className='modal-primary-btn' variant="contained">
          {t("confirmationModal.confirm")}
        </Button>
        <Button onClick={onClose} className='modal-cancel-btn'>
          {t("confirmationModal.cancel")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal;